// ---------------------------------------------------------------------------
// Imperative toast manager — no React context required for calling sites.
// ---------------------------------------------------------------------------

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface ToastItem {
  id: string;
  type: ToastType;
  message: string;
}

type Listener = (toast: ToastItem) => void;

let listener: Listener | null = null;

/** Internal: called by ToastContainer to subscribe for new toast events. */
export function onToast(fn: Listener) {
  listener = fn;
  return () => { listener = null; };
}

let counter = 0;

function emit(type: ToastType, message: string) {
  if (!listener) return;
  const id = `toast-${++counter}-${Date.now()}`;
  listener({ id, type, message });
}

export const toast = {
  success: (msg: string) => emit('success', msg),
  error:   (msg: string) => emit('error', msg),
  warning: (msg: string) => emit('warning', msg),
  info:    (msg: string) => emit('info', msg),
};
